export default `
clip-path: polygon(50% 90%, 19% 100%, 18% 66%, 0% 38%, 30% 26%, 50% 0%, 69% 26%, 100% 38%, 81% 66%, 80% 100%);
`
